const styles = {
  fab: {
    position: 'fixed',
    bottom: 20,
    right: 20,
  },
};

export default styles;
